import { render, staticRenderFns } from "./Paso2.vue?vue&type=template&id=23fa0244&scoped=true"
import script from "./Paso2.vue?vue&type=script&lang=js"
export * from "./Paso2.vue?vue&type=script&lang=js"
import style0 from "./Paso2.vue?vue&type=style&index=0&id=23fa0244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa0244",
  null
  
)

export default component.exports